import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-900 dark:to-gray-800">
            <div className="relative text-center px-4 py-12 max-w-2xl mx-auto">
                {/* Contenu principal */}
                <div className="space-y-8">
                    {/* Logo 404 animé */}
                    <div className="relative">
                        <h1 className="text-[12rem] font-black text-blue-600 dark:text-blue-400 leading-none animate-bounce-slow">
                            404
                        </h1>
                        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-blue-500/20 rounded-full blur-3xl animate-pulse"></div>
                    </div>

                    {/* Message d'erreur */}
                    <div className="space-y-4 animate-fade-in">
                        <h2 className="text-4xl font-bold text-gray-800 dark:text-gray-100">
                            Oups ! Page non trouvée
                        </h2>
                        <p className="text-lg text-gray-600 dark:text-gray-300 max-w-md mx-auto">
                            La page que vous recherchez semble avoir disparu dans le cyberespace.
                        </p>
                    </div>

                    {/* Bouton de retour */}
                    <div className="pt-4 animate-fade-in-up">
                        <Link
                            to="/"
                            className="group relative inline-flex items-center px-8 py-4 text-lg font-medium text-white bg-blue-600 rounded-full overflow-hidden transition-all duration-300 hover:bg-blue-700 hover:scale-105"
                        >
                            <span className="relative z-10 flex items-center gap-2">
                                <svg className="w-5 h-5 transition-transform group-hover:-translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                                </svg>
                                Retour à l'accueil
                            </span>
                            <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound; 